<template>
    <section class="assessmentSection">
        <div class="pageContent">
            <div class="helpTopImage">
                <img src="/img/adt-logo.svg"
                     alt="ADT Logo">
            </div>
            <div class="helpTitle">
                Tested and trusted equipment from the #1 security company in America.
            </div>
            <div class="equipment-features">
                <div class="equipment-feature">Rigouresly tested</div>
                <div class="equipment-feature">Underwriter labs certified</div>
                <div class="equipment-feature">Professionally installed</div>
                <div class="equipment-feature">Self monitored batteries</div>
                <div class="equipment-feature">System self diagnosis</div>
                <div class="equipment-feature">Smash proof protection</div>
            </div>

            <div class="helpEquipment-group"
                 v-for="group in groups">
                <div class="helpEquipment-group-title">{{ group.title }}</div>
                <div class="helpEquipment-list">
                    <!-- EQUIPMENT CARD -->
                    <div class="helpEquipment-list-item"
                         v-for="equipment in filteredItems(group.items)"
                         :class="{'expanded': equipment.expanded}"
                         :id="equipment.name.toSlug()">
                        <true-panel :more-round="true">
                            <!-- COLLAPSED CARD -->
                            <div class="equipment-listing"
                                 v-if="!equipment.expanded">
                                <!-- <div class="clickable main-clickable"  v-show="!equipment.expanded"></div> -->
                                <div class="equipment-listing-image">
                                    <img :src="equipment.image"
                                         :alt="equipment.name">
                                </div>
                                <div class="equipment-listing-title">{{ equipment.name }}</div>
                                <div class="equipment-listing-learn-more"
                                     @click="toggleHelpEquipmentExpanded(equipment.id)">Learn More</div>
                            </div>
                            <!-- END COLLAPSED CARD -->

                            <!-- EXPANDED CARD -->
                            <div class="helpEquipment-card"
                                 v-if="equipment.expanded">
                                <div class="helpEquipment-row flex-end">
                                    <a href="javascript:;"
                                       @click="toggleHelpEquipmentExpanded(equipment.id)">Close</a>
                                </div>
                                <div class="helpEquipment-row">
                                    <div class="helpEquipment-expanded-image">
                                        <img :src="equipment.image"
                                             alt="">
                                    </div>
                                    <div class="helpEquipment-expanded-summary">
                                        <div class="helpEquipment-expanded-title-price">
                                            <div class="helpEquipment-expanded-title">
                                                {{ equipment.name }}
                                            </div>
                                            <div class="helpEquipment-expanded-price">
                                                ${{ equipment.price }}
                                            </div>
                                        </div>
                                        <div class="helpEquipment-expanded-description"
                                             v-html="equipment.description"></div>
                                    </div>
                                </div>
                                <div class="helpEquipment-row">
                                    <div class="helpEquipment-features"
                                         v-html="equipment.features"></div>
                                </div>
                            </div>
                            <!-- END EXPANDED CARD -->
                        </true-panel>
                    </div>
                    <!-- END EQUIPMENT CARD -->
                </div>
            </div>
        </div>

    </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Vue from 'vue'
export default {
    data() {
        return {
            groups: [
                {
                    title: 'The Essentials',
                    items: [
                        8, // Lynx Touch Screen Control
                        1, // Door Intrustion Sensor
                        2, // Window Sensor
                        3, // Motion Sensor
                        4 // Glassbreak Sensor
                    ]
                },
                {
                    title: 'Environmental Protection',
                    items: [
                        5, // Smoke Communicator
                        6, // Carbon Monoxide Communicator
                        7 // Heat Sensor
                    ]
                },
                {
                    title: 'Cameras and Automation',
                    items: [
                        11, // Pulse indoor camera
                        12, // Video Doorbell
                        13, // Smart Thermostat
                        14, // Remove Door lock
                        15 // Lamp Module
                    ]
                }
            ]
        }
    },
    computed: {
        ...mapState(['equipment'])
    },
    methods: {
        ...mapActions(['getEquipmentItems', 'toggleHelpEquipmentExpanded']),

        filteredItems(items) {
            return this.equipment.filter(e => items.indexOf(e.id) > -1)
        }
    },
    mounted() {
        let expandedOnLoad = null
        let that = this
        let name = null
        if (this.$route.query.name) {
            name = this.$route.query.name
            expandedOnLoad = name
        }
        this.getEquipmentItems(expandedOnLoad).then(res => {
            Vue.nextTick(() => {
                let expandedCard = document.getElementById(
                    expandedOnLoad.toSlug()
                )
                let offsetTop = expandedCard.offsetTop
                window.scrollTo(0, offsetTop - 30)
            })
        })

        mixpanel.track('inspectedEquipmentPage', {
            equipment: name || 'menu'
        })
    }
}
</script>

<style lang="css"></style>
